import ControlledPlayer from '../../Entity/ControlledPlayer.js'
import Player from '../../Entity/Player.js'

export const TYPE_PLAYER_JOIN = 'player_join'

class PlayerJoin {
    
    constructor(data) {
        this.data = data
    }
    
    handle(game) {
        const data = this.data;
        const player = (data.self) ? new ControlledPlayer(data.id, game) : new Player(data.id);
        player.getPosition().setX(data.x).setY(data.y);
        player.getSize().setWidth(data.width).setHeight(data.height);
        //game.addPlayer(player);
        game.getPlayers().add(player);
    }
    
}

export default PlayerJoin
